<template>
  <div>
    <loading-spinner v-if="loading"></loading-spinner>
    <v-row v-else>
      <v-col cols="12" v-if="customer_overview">
        <v-card>
          <v-card-text class="py-0">
            <v-row>
              <report-overall-card
                label="Total Users"
                :value="customer_overview.userCount.value | no_decimal"
                flat
              >
                <template v-slot:valueExtension>
                  <compare-text
                    align-end
                    ignore-margin
                    :old-value="customer_overview.userCount.compare"
                    :new-value="customer_overview.userCount.value"
                    :timeframeId="1"
                  >
                  </compare-text>
                </template>
                <div class="caption lighttext--text">
                  Via {{ customer_overview.customers.length }} Companies
                </div>
              </report-overall-card>
              <v-divider vertical></v-divider>
              <report-overall-card
                label="Avg Participation"
                :value="
                  $options.filters.no_decimal(
                    customer_overview.userRecords.value.completion
                  ) + '%'
                "
                :color="
                  $coreScores.getColor(
                    $coreScores.reverseFormat(
                      customer_overview.userRecords.value.completion
                    )
                  )
                "
                flat
              >
                <template v-slot:valueExtension>
                  <compare-text
                    align-end
                    ignore-margin
                    :old-value="
                      customer_overview.userRecords.compare.completion
                    "
                    :new-value="customer_overview.userRecords.value.completion"
                    :timeframeId="1"
                  >
                  </compare-text>
                </template>
                <div class="caption lighttext--text">
                  Overall company participation
                </div>
              </report-overall-card>
              <v-divider vertical></v-divider>
              <report-overall-card
                label="Overall Score"
                :value="customer_overview.score.value | no_decimal"
                :color="
                  $coreScores.getColor(
                    $coreScores.reverseFormat(customer_overview.score.value)
                  )
                "
                flat
              >
                <template v-slot:valueExtension>
                  <compare-text
                    align-end
                    ignore-margin
                    :old-value="customer_overview.score.compare"
                    :new-value="customer_overview.score.value"
                    :timeframeId="1"
                  >
                  </compare-text>
                </template>
                <div class="caption lighttext--text">
                  This score is
                  <span
                    v-bind:style="{
                      color: $coreScores.getColor(
                        this.$coreScores.reverseFormat(
                          customer_overview.score.value
                        )
                      )
                    }"
                    >{{
                      $coreScores.getTitle(
                        this.$coreScores.reverseFormat(
                          customer_overview.score.value
                        )
                      )
                    }}</span
                  >
                </div>
              </report-overall-card>
              <v-divider vertical></v-divider>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-text class="py-0">
            <v-row dense>
              <v-col>
                <v-card-title>Customer Management</v-card-title>
                <v-card-subtitle>
                  Companies that are using CoreCounts
                </v-card-subtitle>
              </v-col>
              <v-spacer> </v-spacer>
              <v-col cols="auto" class="my-auto">
                <v-btn to="/portal/customers/add">
                  <v-icon class="mr-2">create_new_folder</v-icon>
                  Add Company
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <customer-table
              :customers="customers"
              show-plan
              :loading="loading"
            ></customer-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerTable from "@/components/portal/CustomerTable";
import ReportOverallCard from "@/components/reporting/ReportOverallCard";
import CompareText from "@/components/reporting/CompareText";
export default {
  name: "CustomerList",
  components: { CustomerTable, ReportOverallCard, CompareText },
  data: () => ({
    tab: null,
    loading: false
  }),
  computed: {
    ...mapGetters({
      customers: "customer/customers",
      customer_overview: "customer/customer_overview"
    })
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch("customer/getCustomers")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading customers."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
